
const digest = 'fa8fdb60a8cd351edfe75801d488d23343988b03c86bcb8eb9af3e14d7b4c4c2';
const classes = {"wrapper":"_wrapper_4onmb_1","text":"_text_4onmb_4"};
const css = `._wrapper_4onmb_1 {
  text-align: center;
}
._wrapper_4onmb_1 ._text_4onmb_4 {
  margin-top: 20px;
  color: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  